module.exports = __webpack_public_path__ + "img/leaves@4x.dd9f234c.png";